import React, { useState } from 'react';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import CustomerMenuContainer from '../CustomerMenuContainer';
import CustomTooltip from '../CustomTooltip';
import SubMenuContainer from '../SubMenuContainer';
import { HEADER_TYPE } from '../types';
import { getActiveStatus, isTablet, stringAvatar } from '../utils';
import { CUSTOMER_PRIVATE_MENU, DEFAULT_PROPS, LAPTOP_PROPS, TABLET_PROPS } from './constants';
import PrivateLoader from './PrivateLoader';
import * as S from './styles';
const Navigation = ({ type, navItems, customer, shouldShowPrivateLoader }) => {
    const [openedId, setOpenedId] = useState();
    const handleClose = () => {
        setOpenedId(undefined);
    };
    const handleOpen = (id) => {
        setOpenedId(id);
    };
    const MainNavProps = Object.assign(Object.assign({}, DEFAULT_PROPS), (isTablet() ? TABLET_PROPS : LAPTOP_PROPS));
    if (shouldShowPrivateLoader) {
        return (React.createElement(S.CustomNav, { "$type": type },
            React.createElement(PrivateLoader, null)));
    }
    return (React.createElement(S.CustomNav, { "$type": type },
        React.createElement(ClickAwayListener, { onClickAway: handleClose },
            React.createElement(S.CustomList, null,
                navItems.map(({ id, href, title, subMenus, enableBadge = false }) => {
                    const showBadge = enableBadge === true && (customer === null || customer === void 0 ? void 0 : customer.showUnreadMessage) === true;
                    const isActive = getActiveStatus(subMenus, href);
                    const mainHref = href || undefined;
                    return (React.createElement(CustomTooltip, Object.assign({}, MainNavProps, { title: React.createElement(SubMenuContainer, { subMenus: subMenus, clickCallback: handleClose }), key: id, open: openedId === id, onClose: handleClose, onOpen: () => handleOpen(id) }),
                        React.createElement(S.CustomListItem, null,
                            React.createElement(S.CustomLink, { href: mainHref, underline: "none", "$isActive": isActive, onClick: () => handleOpen(id) },
                                React.createElement(S.CustomBadge, { variant: "dot", invisible: !showBadge, color: "error" }, title)))));
                }),
                type === HEADER_TYPE.Private ? (React.createElement(CustomTooltip, Object.assign({}, MainNavProps, { title: React.createElement(CustomerMenuContainer, { isDropdownOpen: openedId === CUSTOMER_PRIVATE_MENU, customer: customer }), key: CUSTOMER_PRIVATE_MENU, open: openedId === CUSTOMER_PRIVATE_MENU, onClose: handleClose, onOpen: () => handleOpen(CUSTOMER_PRIVATE_MENU) }),
                    React.createElement(S.CustomListItem, null,
                        React.createElement(Button, { className: "avatarButton", disableRipple: true, onClick: () => handleOpen(CUSTOMER_PRIVATE_MENU) },
                            React.createElement(Avatar, { className: "avatarName" }, stringAvatar(customer === null || customer === void 0 ? void 0 : customer.displayName)),
                            React.createElement(ChevronLeftIcon, { className: "avatarIcon" }))))) : null))));
};
export default Navigation;
//# sourceMappingURL=index.js.map